<template>
  <div id="app">
    <keep-alive>
      <component :is="isShow"></component>
    </keep-alive>
    
  </div>
</template>

<script>
  import oldIndex from '@/components/oldIndex.vue'
  import newIndex from '@/components/newIndex.vue'
  import pdf from '@/views/pdf.vue'
  import diffPdf from '@/views/diff-pdf.vue'
  import bus from '@/assets/eventBus'
  import g from '@/components/Global.vue'

  export default {
    name: 'App',
    data(){
      return {
        isShow: 'oldIndex',    // 切换组件远期组件与期权组件
      }
    },
    created() {
      // this.gainUrl()
      this.setGlobalData()
      if (sessionStorage.getItem('state')) {
        this.$store.replaceState(Object.assign({}, this.$store.state,
          JSON.parse(sessionStorage.getItem('state'))))
      }

      if (window.addEventListener) {
        window.addEventListener("beforeunload", this.reload, true)
      } else {
        window.attachEvent("onbeforeunload", this.reload)
      }
    },
    methods: {
      reload() {
        sessionStorage.setItem('state', JSON.stringify(this.$store.state))
      },

      gainUrl() {
        this.getSocketBaseUrl().then(res => {
          window.sessionStorage.setItem("socketBaseUrl", JSON.stringify(res))
        })
      },

      setGlobalData() {
        let titleIco = window.sessionStorage.getItem("titleIco")
        if(titleIco) {
          let link = document.getElementsByTagName("link")[0]
          link.href = titleIco
        }
      }
    },
    components: {
      oldIndex,
      newIndex,
      pdf,
      diffPdf,
    },
    watch: {
      $route: {
        handler(to, from){
          if(to.path == '/forwardType' || to.path == '/newForword' || to.path == '/newLayoutForword') {
            this.isShow = 'newIndex'
          } else if(to.path == '/pdf') {
            this.isShow = 'pdf'
          } else if(to.path == '/diff-pdf') {
            this.isShow = 'diffPdf'
          } else {
            this.isShow = 'oldIndex'
          }
        },
        immediate: true,
      },
    }
  }

</script>

<style>
  html {
    font-size: 20px;
  }

  .el-message-box {
    width: 80vw !important;
    max-width: 420px !important;
  }

  .cell  {
    text-align: center;
  }

  .hand {
    cursor: pointer;
  }

  .el-message {
    z-index: 9999;
  }
  .zZindex {
    z-index:3000 !important;
  }
</style>
